import React from "react"

import classes from "./style.module.css"

const Spinner: React.FC = () => <div className={classes.container}></div>

export default Spinner
